<template>
  <section
    class="simple-cta-section-module-component"
    :class="props.data.blue_background_variation ? 'blue-variation' : ''">
    <div
      v-if="props.data.blue_background_variation"
      class="background">
      <img
        src="@/assets/img/counter-section-bg.svg"
        alt="Background" />
    </div>
    <div class="inner-container-with-padding">
      <div class="content">
        <div
          class="left"
          v-html="props.data.title" />
        <div class="right">
          <div
            class="simple-content"
            v-html="props.data.content" />

          <div
            v-if="data.show_button"
            class="inline-block w-fit">
            <ArrowCircleButton
              :link="data.button"
              :color="props.data.blue_background_variation ? 'white' : ''" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "SimpleCTASectionComponent",
  "CLASSNAME": "simple-cta-section-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import ArrowCircleButton from '../utility/ArrowCircleButton.vue'

const props = defineProps(['data'])
</script>

<style lang="scss">
.simple-cta-section-module-component {
  .content {
    @apply flex flex-col px-lg py-10 lg:flex-row lg:py-xl;

    .left {
      @apply lg:w-1/2 lg:flex-[1_0_auto];

      h2 {
        @apply header-2 mb-5 text-bicara-blue lg:mr-auto lg:max-w-[570px];

        strong {
          @apply font-light;
        }
      }
    }

    .right {
      @apply lg:w-1/2 lg:flex-[1_0_auto] lg:pl-xl;

      .link {
        @apply mb-0;
      }

      .simple-content {
        @apply flex flex-col gap-5;

        p {
          @apply body-md text-bicara-dark-blue;
        }
      }
    }
  }

  &.blue-variation {
    @apply relative bg-bicara-blue lg:py-10;

    .background {
      @apply pointer-events-none absolute left-0 top-0 h-full w-full opacity-50;

      img {
        @apply pointer-events-none h-full w-full object-cover object-center;
      }
    }

    .content {
      .left {
        h2 {
          @apply text-white;

          strong {
            @apply font-light text-bicara-yellow;
          }
        }
      }

      .right {
        .simple-content {
          p {
            @apply text-white;
          }
        }
      }
    }
  }
}
</style>
